export const COLUMN_WIDTHS = {
  ASSIGNED_ACCOUNTS: 140,
  CREATED_DATE: 140,
  DESIGN_LEAD: 200,
  NAME: 300,
  TEAM_MEMBERS: 120,
};
